export default "__VITE_PUBLIC_ASSET__e4f08ae7__"